// useBallistics.js — isolates the physics engine from React.
// Subscribes to the calculator store, debounces input changes (~80ms) and
// returns memoised trajectory samples + metrics.
import { useEffect, useMemo, useState } from "react";
import { useShallow } from "zustand/react/shallow";
import { useCalculatorStore } from "@/store/calculatorStore";
import { computeBallistics } from "@/utils/ballisticsMath";

export function useBallistics() {
  const inputs = useCalculatorStore(
    useShallow((s) => ({
      massKg: s.massKg,
      v0: s.v0,
      bc: s.bc,
      zeroDistance: s.zeroDistance,
      sightHeight: s.sightHeight,
      targetDistance: s.targetDistance,
      inclination: s.inclination,
      windSpeed: s.windSpeed,
      windDir: s.windDir,
      tempC: s.tempC,
      altitude: s.altitude,
      pressureHpa: s.pressureHpa,
    }))
  );

  const [debounced, setDebounced] = useState(inputs);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(inputs), 80);
    return () => clearTimeout(t);
  }, [inputs]);

  return useMemo(() => computeBallistics(debounced), [debounced]);
}
